import { render, staticRenderFns } from "./SendOrderDeleteRecord.vue?vue&type=template&id=4428ded0&scoped=true&"
import script from "./SendOrderDeleteRecord.vue?vue&type=script&lang=js&"
export * from "./SendOrderDeleteRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4428ded0",
  null
  
)

component.options.__file = "SendOrderDeleteRecord.vue"
export default component.exports